import { autoinject, transient } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "@rightship-tech/common-ui/services/basic/notification-client.service";
import { DocumentManagementService } from "../../../services/document-management.service";

@autoinject
@transient()
export class DialogRemoveAccess {

    public emails: string[] = [];
    public onSave: () => void;
    private _rightshipInspectionId: number;

    constructor(public dialogClientService: DialogClientService,
        private documentManagementService: DocumentManagementService,
        private notificationClientService: NotificationClientService) {}

    activate(model: { rightshipInspectionId: number, emails: string[], onSave: () => void }) {
        this.emails = model.emails;
        this._rightshipInspectionId = model.rightshipInspectionId;
        this.onSave = model.onSave;
    }

    //Remove access
    async removeAccess() {
        try {
            const result = await this.documentManagementService.removeRightshipInspectionDocumentAccess(this._rightshipInspectionId, this.emails);
            if (result.isSuccess) {
                this.notificationClientService.show("Remove access successfully", "", NotificationType.Success);
                this.dialogClientService.hide(true);
                if (this.onSave) {
                    this.onSave();
                }
            }
            else {
                this.notificationClientService.show(result.message, "", NotificationType.Error);
            }
        }
        catch (error) {
            console.log(error)
            this.notificationClientService.show("An error occurd when trying to send remove access", "", NotificationType.Error);
        }
    }

    //Cancel
    cancel() {
        this.dialogClientService.hide();
    }
}